import React, { useState, useEffect } from 'react';
import CategoryItem from './CategoryItem';
import getPostsByType from '../../../api/graphql/queries/getPostsByType';
import Modal from '../../Modal/Modal';
import AddCategoryForm from './AddCategoryForm';
import LoadIcon from '../../LoadIcon';
import SearchPostsStructure from './SearchPostsStructure';

const CategoriesList = () => {
  const [pcList, setPcList] = useState([]);
  const [isModalOn, setModalState] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  const reFetchCats = () => {
    toggleModal();
    getPostsByType('section')
      .then(({ posts }) => {
        if (posts) {
          setPcList(posts);
        }
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    let isSubscribed = true;
    getPostsByType('section')
      .then(({ posts }) => {
        if (posts && isSubscribed) {
          setPcList(posts);
          setIsLoading(false);
        }
      })
      .catch(err => console.log(err));

    return () => { isSubscribed = false; };
  }, [setPcList]);

  return (
    <>
      <div className="flex justify-between mb-4">
        <SearchPostsStructure />
        <button
          className="font-americaMonoBold text-xs px-6 py-2 rounded-full bg-black text-white uppercase w-210px flex items-center justify-center"
          onClick={toggleModal}
          type="button"
        >
          Add New Category
          <span className="font-icon icon-add-button text-white font-black pl-4 text-base" />
        </button>
      </div>
      {!isLoading ? pcList.map(post => (<CategoryItem key={post._id} {...post} />)) : <LoadIcon />}
      {isModalOn && (
      <Modal handleClick={toggleModal} positionMiddle>
        <AddCategoryForm handleClick={toggleModal} reFetch={reFetchCats} />
      </Modal>
      )}
    </>
  );
};

export default CategoriesList;
